var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"name",attrs:{"fluid":"","id":"helloWorldComponent"}},[_c('h1',{attrs:{"id":"hello"}}),_c('h2',{attrs:{"id":"titles"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }